module.exports = __webpack_public_path__ + "static/img/physicalTraining.19676f06.svg";